import { render, staticRenderFns } from "./TransactionData.vue?vue&type=template&id=973ba770"
import script from "./TransactionData.vue?vue&type=script&lang=js"
export * from "./TransactionData.vue?vue&type=script&lang=js"
import style0 from "./TransactionData.vue?vue&type=style&index=0&id=973ba770&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports